import { capitalCase, sentenceCase } from "change-case";
export function enumAsSelectArray(enumerator, capital_case = false) {
    const options = {
        splitRegexp: /([a-z])([A-Z0-9])/g,
    };
    return Object.keys(enumerator).map(name => {
        return {
            label: capital_case ? capitalCase(name, options) : sentenceCase(name, options),
            value: enumerator[name]
        };
    });
}
export function getKeyByValue(enumObject, value) {
    const keys = Object.keys(enumObject);
    for (const key of keys) {
        if (enumObject[key] === value) {
            return key;
        }
    }
    return undefined; // Value not found
}
export var ActionAfterSave;
(function (ActionAfterSave) {
    ActionAfterSave[ActionAfterSave["Close"] = 0] = "Close";
    ActionAfterSave[ActionAfterSave["AddAnother"] = 1] = "AddAnother";
    ActionAfterSave[ActionAfterSave["KeepOpen"] = 2] = "KeepOpen";
    ActionAfterSave[ActionAfterSave["Navigate"] = 3] = "Navigate"; // Navigate to the edit page for the item
})(ActionAfterSave || (ActionAfterSave = {}));
export var AddressType;
(function (AddressType) {
    AddressType[AddressType["Main"] = 0] = "Main";
    AddressType[AddressType["Usual"] = 1] = "Usual";
    AddressType[AddressType["Current"] = 2] = "Current";
    AddressType[AddressType["Postal"] = 3] = "Postal";
    AddressType[AddressType["Emergency"] = 4] = "Emergency";
    AddressType[AddressType["GP"] = 5] = "GP";
    AddressType[AddressType["Other"] = 6] = "Other";
})(AddressType || (AddressType = {}));
export var AustralianState;
(function (AustralianState) {
    AustralianState["NewSouthWales"] = "NSW";
    AustralianState["Victoria"] = "VIC";
    AustralianState["Queensland"] = "QLD";
    AustralianState["SouthAustralia"] = "SA";
    AustralianState["WesternAustralia"] = "WA";
    AustralianState["Tasmania"] = "TAS";
    AustralianState["NorthernTerritory"] = "NT";
    AustralianState["AustralianCapitalTerritory"] = "ACT";
    AustralianState["OtherTerritories"] = "OTH";
})(AustralianState || (AustralianState = {}));
export var AustralianStateIdentifier;
(function (AustralianStateIdentifier) {
    AustralianStateIdentifier["NewSouthWales"] = "1";
    AustralianStateIdentifier["Victoria"] = "2";
    AustralianStateIdentifier["Queensland"] = "3";
    AustralianStateIdentifier["SouthAustralia"] = "4";
    AustralianStateIdentifier["WesternAustralia"] = "5";
    AustralianStateIdentifier["Tasmania"] = "6";
    AustralianStateIdentifier["NorthernTerritory"] = "7";
    AustralianStateIdentifier["AustralianCapitalTerritory"] = "8";
    AustralianStateIdentifier["OtherTerritories"] = "9";
})(AustralianStateIdentifier || (AustralianStateIdentifier = {}));
export var Method;
(function (Method) {
    Method["Put"] = "PUT";
    Method["Delete"] = "DELETE";
    Method["Post"] = "POST";
    Method["Get"] = "GET";
})(Method || (Method = {}));
export var ClientStatus;
(function (ClientStatus) {
    ClientStatus["Current"] = "Current";
    ClientStatus["WaitListed"] = "Waiting";
    ClientStatus["NotAccepted"] = "NonAccp";
    ClientStatus["Exited"] = "Exited";
})(ClientStatus || (ClientStatus = {}));
export var WorkerStatus;
(function (WorkerStatus) {
    WorkerStatus["Active"] = "Active";
    WorkerStatus["Waiting"] = "Waiting";
    WorkerStatus["OnHold"] = "OnHold";
    WorkerStatus["Inactive"] = "Inactiv";
})(WorkerStatus || (WorkerStatus = {}));
export var CustomFieldType;
(function (CustomFieldType) {
    CustomFieldType["Checkbox"] = "checkbox";
    CustomFieldType["Colour"] = "color";
    CustomFieldType["Date"] = "date";
    CustomFieldType["DatetimeLocal"] = "datetime-local";
    CustomFieldType["Time"] = "time";
    CustomFieldType["Number"] = "number";
    CustomFieldType["Email"] = "email";
    CustomFieldType["Phone"] = "tel";
    CustomFieldType["Textarea"] = "textarea";
    CustomFieldType["Text"] = "text";
})(CustomFieldType || (CustomFieldType = {}));
export var BootstrapContextualButtonClass;
(function (BootstrapContextualButtonClass) {
    BootstrapContextualButtonClass["Default"] = "default";
    BootstrapContextualButtonClass["Primary"] = "primary";
    BootstrapContextualButtonClass["Success"] = "success";
    BootstrapContextualButtonClass["Info"] = "info";
    BootstrapContextualButtonClass["Warning"] = "warning";
    BootstrapContextualButtonClass["Danger"] = "danger";
    BootstrapContextualButtonClass["Link"] = "link";
})(BootstrapContextualButtonClass || (BootstrapContextualButtonClass = {}));
export var BootstrapSize;
(function (BootstrapSize) {
    BootstrapSize["xs"] = "xs";
    BootstrapSize["sm"] = "sm";
    BootstrapSize["md"] = "md";
    BootstrapSize["lg"] = "lg";
    BootstrapSize["xl"] = "xl";
})(BootstrapSize || (BootstrapSize = {}));
export var FontAwesomeSize;
(function (FontAwesomeSize) {
    FontAwesomeSize["md"] = "md";
    FontAwesomeSize["lg"] = "lg";
    FontAwesomeSize["x2"] = "2x";
    FontAwesomeSize["x3"] = "3x";
    FontAwesomeSize["x4"] = "4x";
    FontAwesomeSize["x5"] = "5x";
})(FontAwesomeSize || (FontAwesomeSize = {}));
export var NdiaType;
(function (NdiaType) {
    NdiaType["Ndia"] = "ndia";
    NdiaType["SelfManaged"] = "ndia_bill";
    NdiaType["PlanManaged"] = "ndia_plan_managed";
})(NdiaType || (NdiaType = {}));
export const NdiaTypeSelections = [
    {
        label: 'NDIA',
        value: NdiaType.Ndia
    },
    {
        label: 'Self Managed',
        value: NdiaType.SelfManaged
    },
    {
        label: 'Plan Managed',
        value: NdiaType.PlanManaged
    },
];
export var NdisPriceLimitType;
(function (NdisPriceLimitType) {
    NdisPriceLimitType["PriceLimitedSupports"] = "Price Limited Supports";
    NdisPriceLimitType["NotionalPricedSupports"] = "Unit Price = $1";
    NdisPriceLimitType["QuotableSupports"] = "Quotable Supports";
})(NdisPriceLimitType || (NdisPriceLimitType = {}));
export var NdisPriceRegion;
(function (NdisPriceRegion) {
    NdisPriceRegion["AustralianCapitalTerritory"] = "act";
    NdisPriceRegion["NewSouthWales"] = "nsw";
    NdisPriceRegion["NorthernTerritory"] = "nt";
    NdisPriceRegion["Queensland"] = "qld";
    NdisPriceRegion["SouthAustralia"] = "sa";
    NdisPriceRegion["Tasmania"] = "tas";
    NdisPriceRegion["Victoria"] = "vic";
    NdisPriceRegion["WesternAustralia"] = "wa";
    NdisPriceRegion["Remote"] = "remote";
    NdisPriceRegion["VeryRemote"] = "very_remote";
})(NdisPriceRegion || (NdisPriceRegion = {}));
export var ApiSetting;
(function (ApiSetting) {
    ApiSetting["Ndis"] = "ndis";
    ApiSetting["EmailToSms"] = "emailtosms";
    ApiSetting["ExtraNdis"] = "extrandis";
    ApiSetting["AutoAllocations"] = "autoallocations";
    ApiSetting["Trips"] = "trips";
    ApiSetting["WorkerTimesheet"] = "workertimesheet";
    ApiSetting["Dex"] = "dex";
    ApiSetting["Elmo"] = "elmo";
    ApiSetting["Myob"] = "myob";
    ApiSetting["Keypay"] = "keypay";
    ApiSetting["Reckon"] = "reckon";
    ApiSetting["Xero"] = "xero";
})(ApiSetting || (ApiSetting = {}));
export var WorkerLevel;
(function (WorkerLevel) {
    WorkerLevel["Administrator"] = "administrator";
    WorkerLevel["Coordinator"] = "coordinator";
    WorkerLevel["Worker"] = "worker";
})(WorkerLevel || (WorkerLevel = {}));
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["Monday"] = "monday";
    DayOfWeek["Tuesday"] = "tuesday";
    DayOfWeek["Wednesday"] = "wednesday";
    DayOfWeek["Thursday"] = "thursday";
    DayOfWeek["Friday"] = "friday";
    DayOfWeek["Saturday"] = "saturday";
    DayOfWeek["Sunday"] = "sunday";
})(DayOfWeek || (DayOfWeek = {}));
export var ReportSupportCancellationInclusion;
(function (ReportSupportCancellationInclusion) {
    ReportSupportCancellationInclusion["All"] = "all";
    ReportSupportCancellationInclusion["None"] = "none";
    ReportSupportCancellationInclusion["ClientBillable"] = "client_billable";
    ReportSupportCancellationInclusion["WorkerPayable"] = "worker_payable";
    ReportSupportCancellationInclusion["Both"] = "both";
})(ReportSupportCancellationInclusion || (ReportSupportCancellationInclusion = {}));
export var ReportExportFormat;
(function (ReportExportFormat) {
    ReportExportFormat["Csv"] = "csv";
    ReportExportFormat["Pdf"] = "pdf";
    ReportExportFormat["Xlsx"] = "xlsx";
})(ReportExportFormat || (ReportExportFormat = {}));
export var InvoiceCalculationMethod;
(function (InvoiceCalculationMethod) {
    InvoiceCalculationMethod["Other"] = "other";
    InvoiceCalculationMethod["TotalCost"] = "total";
    InvoiceCalculationMethod["FeesCharged"] = "fees_charged";
})(InvoiceCalculationMethod || (InvoiceCalculationMethod = {}));
